import { render, staticRenderFns } from "./KpiList.vue?vue&type=template&id=fec49e00&scoped=true&"
import script from "./KpiList.vue?vue&type=script&lang=js&"
export * from "./KpiList.vue?vue&type=script&lang=js&"
import style0 from "./KpiList.vue?vue&type=style&index=0&id=fec49e00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec49e00",
  null
  
)

export default component.exports